import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class ChangeSubscriptionArgs {
  @Field()
  newPlan!: string

  @Field()
  oldPlan!: string

  @Field()
  newCycle!: string

  @Field(t => Int, { nullable: true })
  proratedDate?: number

  @Field({ nullable: true })
  ipAddress?: string
}
